import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { generateTelegramLink } from "../data/telegramLinks";

export const MobileStickyCTA = () => {
  const { t } = useLanguage();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 600);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          className="md:hidden fixed bottom-0 inset-x-0 z-40 px-4 pb-4 pt-3 glass-strong border-t border-[#D7B56D]/20"
          data-testid="mobile-sticky-cta"
        >
          <div className="flex items-center gap-3">
            <div className="flex-1">
              <div className="font-mono text-[9px] uppercase tracking-[0.2em] text-[#A9824A]">
                {t("stickyText")}
              </div>
              <div className="font-display text-[13px] font-bold text-[#F5F1EA] leading-tight mt-0.5">
                {t("ctaRequestOnboarding")}
              </div>
            </div>
            <a
              href={generateTelegramLink("private-support")}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold !py-2.5 !px-4 text-[11px]"
              data-testid="mobile-sticky-cta-btn"
            >
              <MessageCircle size={12} /> Telegram
            </a>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
